export class ExportarUnidadTransporteDTO {
    [key: string]: any;
    codigo?: string;
    nombre?: string;
    estado?: string;
    ruc?: string;
    hub?: string;
    placa?: string;
    capacidad?: string | number;
    cargaUtil?: string | number;
    unidadTransporte?: string;
}
